import { httpClient } from '@/lib/api/httpClient'
import type {
  VendorCreateInput,
  FoodVendorCreateOrUpdateInput,
  ClothVendorCreateOrUpdateInput,
  CreateVendorLocationInput,
  CreateClosedDayInput,
  CreateCategoryInput,
  SendEmailInput,
} from '@/shared/types'

export const onboardingApi = {
  createBaseVendor: async (data: VendorCreateInput): Promise<string> => {
    const response = await httpClient.post('/vendors', data)
    return response.data?.data?.vendorId
  },

  createFoodVendor: async (vendorId: string, data: Omit<FoodVendorCreateOrUpdateInput, 'vendorId'>): Promise<void> => {
    await httpClient.post(`/vendors/${vendorId}/food`, { ...data, vendorId })
  },

  createClothingVendor: async (
    vendorId: string,
    data: Omit<ClothVendorCreateOrUpdateInput, 'vendorId'>
  ): Promise<void> => {
    await httpClient.post(`/vendors/${vendorId}/clothing`, { ...data, vendorId })
  },

  createLocation: async (data: CreateVendorLocationInput): Promise<void> => {
    await httpClient.post(`/vendors/${data.vendorId}/${data.role}/locations`, data)
  },

  createClosedDays: async (vendorId: string, data: CreateClosedDayInput): Promise<void> => {
    await httpClient.post(`/vendors/${vendorId}/closed-days`, { ...data, vendorId })
  },

  createCategories: async (vendorId: string, data: CreateCategoryInput): Promise<void> => {
    await httpClient.post(`/vendors/${vendorId}/categories`, { ...data, vendorId })
  },

  sendEmail: async (data: SendEmailInput): Promise<void> => {
    await httpClient.post(`/vendors/email/${data.type}`, { email: data.email, type: data.type })
  },
}
